import { defineStore } from 'pinia';
import { ref } from 'vue';

import { useUserStore } from '@/stores/user';

interface UserStorage {
  [key: string]: any;
}

const useStorageStore = defineStore('storage', () => {
  const userStore = useUserStore();

  // 用户纬度的缓存
  const userStorage = ref({} as UserStorage);

  const initUserStorage = () => {
    const storage = localStorage?.getItem(userStore.trId);
    if (storage) {
      userStorage.value = JSON.parse(storage);
    }
  };

  const updateUserStorage = (config: UserStorage) => {
    const mergeConfig = {
      ...userStorage.value,
      ...config
    };
    userStorage.value = mergeConfig;

    localStorage?.setItem(userStore.trId, JSON.stringify(mergeConfig));
  };

  const initStorage = () => {
    initUserStorage();
  };

  return {
    initStorage,
    userStorage,
    updateUserStorage
  };
});

export default useStorageStore;
